import qc from 'qc'
import i18n from '@ps/lang'
import { carouselStyleIcon } from '@ps/utils/carousel-style-icon'
import {
  CarouselType,
  Direction,
  PlayMod,
  TriggerManual,
} from '@ps/views/workbench/right-pane/carousel/config'

// 轮播组类型
export interface CarouselGroup {
  carouselId: string
  items: qc.Node[]
  prev: qc.Node
  next: qc.Node
  displaySpace: number
  displayWidth: number
  displayHeight: number
}

export const directionOptions = [
  {
    label: i18n.t('workbench.carousel.direction.vertical'),
    value: Direction.vertical,
  },
  {
    label: i18n.t('workbench.carousel.direction.horizontal'),
    value: Direction.horizontal,
  },
]

export const carouselTypeOptions = [
  {
    label: i18n.t('workbench.carousel.carouselType.normal'),
    value: CarouselType.NormalCarousel,
    icon: carouselStyleIcon[CarouselType.NormalCarousel],
  },
  {
    label: i18n.t('workbench.carousel.carouselType.pulseScale'),
    value: CarouselType.PulseScaleCarousel,
    icon: carouselStyleIcon[CarouselType.PulseScaleCarousel],
  },
  {
    label: i18n.t('workbench.carousel.carouselType.rollScale'),
    value: CarouselType.RollScaleCarousel,
    icon: carouselStyleIcon[CarouselType.RollScaleCarousel],
  },
  {
    label: i18n.t('workbench.carousel.carouselType.opacity'),
    value: CarouselType.OpacityCarousel,
    icon: carouselStyleIcon[CarouselType.OpacityCarousel],
  },
  {
    label: i18n.t('workbench.carousel.carouselType.opacityScale'),
    value: CarouselType.OpacityScaleCarousel,
    icon: carouselStyleIcon[CarouselType.OpacityScaleCarousel],
  },
]

export const playModOptions = [
  {
    label: i18n.t('workbench.carousel.playMode.auto'),
    value: PlayMod.auto,
  },
  {
    label: i18n.t('workbench.carousel.playMode.manual'),
    value: PlayMod.manual,
  },
]

export const triggerManualOptions = [
  {
    label: i18n.t('workbench.carousel.triggerMode.click'),
    value: TriggerManual.click,
  },
  {
    label: i18n.t('workbench.carousel.triggerMode.drag'),
    value: TriggerManual.drag,
  },
]

export const carouselStyleDefaultConfig = {
  [CarouselType.NormalCarousel]: {
    playMode: [PlayMod.manual],
    triggerManual: [TriggerManual.drag],
    stayTime: 0,
    enableScaleMask: false,
    displayNum: 7,
    direction: Direction.horizontal,
    animationDuration: 0,
    enableComponent: true,
    carouselOpacity: {
      min: 1,
      max: 1,
    },
    carouselScale: {
      min: 1,
      max: 1,
    },
    displayWidth: 200,
    displayHeight: 200,
    displaySpace: 260,
  },
  [CarouselType.PulseScaleCarousel]: {
    playMode: [PlayMod.manual],
    triggerManual: [TriggerManual.click],
    stayTime: 0,
    enableScaleMask: false,
    displayNum: 1,
    direction: Direction.horizontal,
    animationDuration: 0,
    enableComponent: true,
    carouselOpacity: {
      min: 0,
      max: 1,
    },
    carouselScale: {
      min: 1,
      max: 1,
    },
    displayWidth: 500,
    displayHeight: 500,
    displaySpace: 0,
  },
  [CarouselType.RollScaleCarousel]: {
    playMode: [PlayMod.manual],
    triggerManual: [TriggerManual.drag],
    stayTime: 0,
    enableScaleMask: false,
    displayNum: 5,
    direction: Direction.horizontal,
    animationDuration: 0.1,
    enableComponent: true,
    carouselOpacity: {
      min: 0.6,
      max: 1,
    },
    carouselScale: {
      min: 0.6,
      max: 1,
    },
    displayWidth: 500,
    displayHeight: 500,
    displaySpace: 120,
  },
  [CarouselType.OpacityCarousel]: {
    playMode: [PlayMod.manual],
    triggerManual: [TriggerManual.drag],
    stayTime: 0,
    enableScaleMask: false,
    displayNum: 3,
    direction: Direction.horizontal,
    animationDuration: 0,
    enableComponent: true,
    carouselOpacity: {
      min: 0.2,
      max: 1,
    },
    carouselScale: {
      min: 1,
      max: 1,
    },
    displayWidth: 600,
    displayHeight: 600,
    displaySpace: 670,
  },
  [CarouselType.OpacityScaleCarousel]: {
    playMode: [PlayMod.manual],
    triggerManual: [TriggerManual.click, TriggerManual.drag],
    stayTime: 0,
    enableScaleMask: false,
    displayNum: 3,
    direction: Direction.horizontal,
    animationDuration: 0.3,
    enableComponent: true,
    carouselOpacity: {
      min: 0,
      max: 1,
    },
    carouselScale: {
      min: 0,
      max: 1,
    },
    displayWidth: 300,
    displayHeight: 300,
    displaySpace: 400,
  },
}

export function switchArrayToObject(list) {
  return list.reduce((result, value, index) => {
    result[index] = value
    return result
  }, {})
}
